






















































































































































































































































































import Button from "@/shared/components/ui/Button.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { PlanType, FetchState, PlanDetails, UserOnboardingSteps } from "@/shared/types";
import * as _ from "lodash";
import moment from "moment";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useWizardStore } from "@/employee/store/wizard";
import { useSignUpStore } from "@/employee/store/signup";
import { useContributionStore } from "@/shared/store/contribution";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { BankCustodian } from "@/admin/types";
import * as RouteNames from "@/employee/route-names";
import { Validator } from "vee-validate";

@Component({
  components: {
    RadioButton,
    Button
  }
})

export default class IndividualPlanDetails extends Vue {
  $validator: Validator;

  signupStore = useSignUpStore();
  contactInfoStore = useContactInfoStore();
  wizardStore = useWizardStore();
  contributionStore = useContributionStore();
  custodianSettingsStore = useCustodianSettingsStore();

  selectedPlanType = "";
  availablePlanTypeOptions = [
    { value: "", text: "Select your answer" },
    { value: PlanType.Individual, text: "Me" },
    { value: PlanType.Family, text: "Me and others" }
  ];

  @Prop()
  inWizard: boolean;
  isSubmitting = false;
  showContributions = true;
  formModel: PlanDetails = {
      planType: PlanType.Individual,
      healthPlanEffectiveDate: null,
      effectiveDate: moment().format("YYYY-MM-DD"),
      otherHsaAmount: 0,
      enrollHsa: true
    };

  resetForm () {
    this.formModel = {
      planType: PlanType.Individual,
      effectiveDate: moment().format("YYYY-MM-DD"),
      otherHsaAmount: 0,
      enrollHsa: false,
      healthPlanEffectiveDate: null
    };

    this.selectedPlanType = "";
  }

  mounted () {
    this.signupStore.getContributionLimits();
    this.contributionStore.getPlanDetails();
    this.contactInfoStore.getContactInformation();
    this.syncData();
  }

  syncData () {
    this.formModel = _.cloneDeep(this.contributionStore.planDetails);
    this.showContributions = this.formModel.otherHsaAmount > 0;
    this.selectedPlanType = this.formModel.planType;
  }

  @Watch("contributionStore.planDetails")
  onPlanStateChanged () {
    this.syncData();
  }

  get isHsaBank () {
    return this.custodianSettingsStore.userHsaCustodian === BankCustodian.HsaBank;
  }

  get isLoaded () {
    return this.contactInfoStore.contactInformationState === FetchState.Loaded
      && this.signupStore.isLoaded
      && this.contributionStore.planDetailsFetchState === FetchState.Loaded;
  }

  get personalDetailsRoute () {
    return { name: RouteNames.NamedOnboarding, params: { stepKey: "personal-details" } };
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  get showContributionSection () {
    if (!this.formModel.enrollHsa) return false;

    return this.formModel.effectiveDate === null
      || new Date(this.formModel.effectiveDate).getFullYear() < new Date().getFullYear() + 1;
  }

  onSubmit () {
    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;

    this.$validator.validateAll().then(result => {
      if (!result) {
        this.isSubmitting = false;
        return;
      }

      if (this.isHsaBank) {
        this.mapFormModelForHsaBank(this.formModel);
      }

      this.contributionStore.savePlanDetails(this.formModel).then(() => {
        this.contributionStore.setPlanDetails(this.formModel);
        this.wizardStore.getWizardState();
        this.$emit("complete");
        this.$emit("isFamilyPlan", this.formModel.planType === PlanType.Family);
        this.isSubmitting = false;
      })
      .catch(() => this.isSubmitting = false);
    });
  }

  mapFormModelForHsaBank (formModel: PlanDetails): void {
    formModel.enrollHsa = true;
    formModel.planType = this.mapToPlanType(this.selectedPlanType);
    formModel.otherHsaAmount = 0;
  }

  mapToPlanType (selectedPlanType: string): PlanType {
    switch (selectedPlanType) {
      case PlanType.Individual:
        return PlanType.Individual;
      case PlanType.Family:
        return PlanType.Family;
    }
  }

  goBack () {
    const indexOfCurrentStep = this.wizardStore.shownStatuses
      .findIndex(s => s.step === UserOnboardingSteps.YourPlan);

    if (indexOfCurrentStep < 1) {
      return;
    }

    const previousStep = this.wizardStore.shownStatuses[indexOfCurrentStep - 1];

    this.goToStep(previousStep.stepKey);
  }

  goToStep (stepKey: string) {
    this.$router.push({ name: RouteNames.NamedOnboarding, params: { stepKey } });
  }
}
